export function reduxFunction(type, action, value, next = null, preLoader = false, redirect = null) {
    return {
        type: type,
        action: action,
        value: value,
        next: next,
        preLoader: preLoader,
        redirect: redirect
    }
}